import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid'

interface TestResult {
  passed: boolean;
}

interface TestResultCirclesProps {
  results: TestResult[];
}

const TestResultCircles: React.FC<TestResultCirclesProps> = ({ results }) => {
  return (
    <div className="test-result-circles-container">
      <div className="test-cases-label">Test cases:</div>
      <div className="test-result-circles-wrapper">
        <div className="test-result-circles" style={{ display: 'flex', gap: '8px' }}>
          {results.map((result, index) => (
            <div 
              key={index} 
              style={{
                backgroundColor: result.passed ? '#dcfce7' : '#fee2e2',
                width: '26px',
                height: '26px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {result.passed ? 
                <CheckCircleIcon style={{ width: '26px', height: '26px', color: '#16a34a' }} /> : 
                <XCircleIcon style={{ width: '26px', height: '26px', color: '#dc2626' }} />
              }
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestResultCircles;